import React from 'react'
import classNames from 'classnames'
import { node, bool } from 'prop-types'

import styles from '../Card.module.scss'
import Inline from '../../Inline'
import Icon from '../../Icon'

const CardButton = ({ children, inverse }) => (
  <div className={classNames(styles.CardButton, inverse && styles.inverse)}>
    <Inline center middle>
      {children}
      <Icon a11yText="" type="arrow-right" />
    </Inline>
  </div>
)

CardButton.propTypes = {
  children: node,
  inverse: bool
}

export default CardButton
